/**
 * Tenant (Customer) selecionado por um administrador do cliente proprietário para operar
 * o ChatInDoc em outro cliente. Quando nulo, todas as operações usam o tenant do usuário autenticado.
 */
class ChatTenantService {
  private activeTenantId: string | null = null;

  setActiveTenantId(tenantId: string | null): void {
    const normalized = tenantId?.trim();
    this.activeTenantId = normalized ? normalized : null;
  }

  getActiveTenantId(): string | null {
    return this.activeTenantId;
  }

  private getStorageCustomerId(): string | null {
    if (typeof window === 'undefined') {
      return null;
    }
    return (
      sessionStorage.getItem('@KnowInDoc:customer_id')?.trim() ||
      localStorage.getItem('@KnowInDoc:customer_id')?.trim() ||
      null
    );
  }

  /** Query/body param somente quando o tenant selecionado difere do tenant do token. */
  buildCustomerIdParams(): { customerId?: string } {
    if (!this.activeTenantId) {
      return {};
    }

    const storageCustomerId = this.getStorageCustomerId();
    if (storageCustomerId && this.activeTenantId === storageCustomerId) {
      return {};
    }

    return { customerId: this.activeTenantId };
  }
}

export const chatTenantService = new ChatTenantService();
